(() => {
  function removeGift(removeditems) {
    // console.log("removeGift");
    if (!removeditems) return;
    // update cart
    fetch('/cart/update.js', {
      body: JSON.stringify({
        updates: removeditems,
      }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
      },
    }).then((response) => {
      // console.log("response after removing", response );

      if (response.ok) {
        // We simply trigger an event so the mini-cart can re-render
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        if (window.themeVariables.settings.pageType === 'cart')
          window.location.reload();
      }
    });
  }

  function addGift(addeditems) {
    // console.log("addGift");
    if (!addeditems) return;
    if (localStorage.getItem('gift_removed')) return;
    // update cart
    fetch('/cart/add.js', {
      body: JSON.stringify({
        items : addeditems
      }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
      },
    }).then((response) => {
      // console.log("response after addition", response );
      if (response.ok) {
        // We simply trigger an event so the mini-cart can re-render
        localStorage.setItem('gift_variant_id',window.CG.gift_variant);
        localStorage.setItem('gift_variant_id_2',window.CG.gift_variant_2);

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        if (window.themeVariables.settings.pageType === 'cart')window.location.reload();
      }
    });
  }

  function gamificationHandle() {
    handlePreviousGifts();
    if(document.querySelector('.gamification') == null) return;

    let gift1InCart = false,
        gift2InCart = false,
        gift1addition = false,
        gift2addition = false,
        gift1removing = false,
        gift2removing = false;

    let current_status = window.current_status.split(',');
    // console.log("current_status:",current_status);
    let gift1Variant = document.querySelector('.gamification').getAttribute('gift-variant');
    if (document.querySelector('.line-item[data-gift="true"]')) {
      gift1InCart = true;
    }
    [gift1addition,gift1removing] = handleGift(current_status[0],gift1InCart);

    let gift2Variant = document.querySelector('.gamification').getAttribute('gift2-variant');
    if (gift2Variant && current_status[2] != null) {
      if (document.querySelector('.line-item[data-gift2="true"]')) {
        gift2InCart = true;
      }
      [gift2addition,gift2removing] = handleGift(current_status[2],gift2InCart);
    }
    giftsConditions(gift1Variant,gift2Variant,gift1addition,gift2addition,gift1removing,gift2removing);
  }

  function handleGift(current_status,giftInCart){
    let giftGrantedState = false, giftaddition = false, giftremoving = false;

    if (current_status === 'all_granted') {
      giftGrantedState = true;
    }

    if (!giftInCart && giftGrantedState) {
      giftaddition = true;
      // console.log("add gift true");
    } 
    else if (giftInCart && !giftGrantedState) {
      giftremoving = true;
      // console.log("remove gift true");
    }
    return [giftaddition,giftremoving];
  }

  function giftsConditions(gift1Variant,gift2Variant,gift1addition,gift2addition,gift1removing,gift2removing){
    if(gift1addition && gift2addition ){
      // add 2 gifts together
      let items = [
        {
          id: parseInt(gift1Variant, 10),
          quantity: 1,
          properties: { "Gift": "Free Gift" },
        },          
        {
          id: parseInt(gift2Variant, 10),
          quantity: 1,
          properties: { "Gift": "Free Gift" },
        },
      ];
      addGift(items);
    }
    else if(gift1removing && gift2removing ){
      // remove 2 gifts together
      let items= {
          [parseInt(gift1Variant, 10)]: 0,
          [parseInt(gift2Variant, 10)]: 0,
        }
      removeGift(items);
    }
    else{
      // add gift 1 alone
      if(gift1addition ){
        let items = [
          {
            id: parseInt(gift1Variant, 10),
            quantity: 1,
            properties: { "Gift": "Free Gift" },
          }
        ];
        addGift(items);
      }
      // add gift 2 alone
      else if( gift2addition ){
        let items = [         
          {
            id: parseInt(gift2Variant, 10),
            quantity: 1,
            properties: { "Gift": "Free Gift" },
          },
        ];
        addGift(items);
      }
      // remove gift 1 alone
      else if(gift1removing){
        let items= {
            [parseInt(gift1Variant, 10)]: 0,
          }
        removeGift(items);
      }
        // remove gift 2 alone
      else if(gift2removing ){
        let items= {
            [parseInt(gift2Variant, 10)]: 0,
          }
        removeGift(items);
      }
    }
  }

  function handleStatusChange() {
    setTimeout(() => {
      // console.log("window.current_status:",window.current_status);
      let current_status = window.current_status ? window.current_status.split(',') : 'hidden';
      if (current_status !== 'hidden') gamificationHandle();
    }, 1000);
  }

  function handlePreviousGifts(){
    let prev_gifts = document.querySelectorAll(".line-item[previousfreegift]");
    if(prev_gifts.length <= 0) return;
    console.log("handlePreviousGifts", prev_gifts);
    let item_removed = {};
    prev_gifts.forEach(gift => {
      item_removed[parseInt(gift.getAttribute("previousfreegift"))] = 0;
    });
    removeGift(item_removed);
  }

  window.addEventListener('load', () => {
    // console.log("load");
    handlePreviousGifts();
    handleStatusChange();
  });

  window.addEventListener('cart:change', () => {
    // console.log("cart:change");  
    handleStatusChange();
  });

  document.addEventListener('line-item:change', function(event) {
    if(event.target.getAttribute("data-gift") == null && event.target.getAttribute("data-gift2") == null){
      // console.log("clear local storage", event);
      localStorage.removeItem('gift_removed');
    }
  });

  document.addEventListener('variant:add', function(event) {
    // console.log("variant:add");
    localStorage.removeItem('gift_removed');
  });

})();